import { Avatar, Button, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Read-only account view. Name + email come from the authenticated JWT and
 * are owned by Zitadel; to edit them, users go through an administrator.
 * The "Change password" button jumps into the standard reset flow.
 */
export function Account() {
  const { user } = useAuth();
  const displayName = user?.name || user?.email || 'Account';
  const avatarInitial = displayName.charAt(0).toUpperCase();

  return (
    <Stack spacing={3}>
      <Typography
        variant="h3"
        component="h1"
        align="center"
      >
        Account
      </Typography>

      <Paper sx={{ p: { xs: 2.5, sm: 4 } }}>
        <Stack spacing={3} alignItems="center">
          <Avatar
            sx={(t) => ({
              width: { xs: 96, sm: 120 },
              height: { xs: 96, sm: 120 },
              fontSize: { xs: 40, sm: 48 },
              bgcolor: t.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'grey.200',
              color: 'text.primary',
            })}
          >
            {avatarInitial}
          </Avatar>

          <Stack spacing={0.5} alignItems="center">
            <Typography variant="h5" fontWeight={600}>
              {displayName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user?.email}
            </Typography>
            {user?.roles?.length ? (
              <Typography variant="caption" color="text.secondary">
                Role: {user.roles.join(', ')}
              </Typography>
            ) : null}
          </Stack>

          <Button component={RouterLink} to="/password-reset" variant="outlined">
            Change password
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
